import { Client } from '@/manager/client/client.model';
import { TagInterface } from '@/manager/convocation/interfaces/tag.interface';
import { PaymentStatusInterface } from '@/manager/convocation/interfaces/paymentStatus.interface';
import { Note } from '@/manager/convocation/note.model';
import { Purchase } from '@/clickbuy/purchase/models/purchase.model';

export interface ParticipantMassiveEmail {
    email: string;
}

export interface ParticipantInterface {
    id?: string;
    checked?: boolean;
    client?: Client;
    confirmation?: boolean;
    diplomaDeliverable?: boolean;
    diplomaDelivered?: boolean;
    emailConf?: boolean;
    emailSend?: boolean;
    numberOfNotes?: number;
    notes?: Note[];
    out?: boolean;
    purchase?: Purchase;
    budget?: string;
    participantList?: boolean;
    paymentStatus?: PaymentStatusInterface;
    phoneConf?: boolean;
    phoneSend?: boolean;
    positionParticipantList?: number;
    positionRepeaterList?: number;
    positionWaitingList?: number;
    postpone?: boolean;
    postponable?: boolean;
    repeated?: boolean;
    repeaterList?: boolean;
    reservedSeat?: object[];
    tag: TagInterface[];
    ticketDownloaded?: boolean;
    transferConvocation?: boolean;
    waitingList?: boolean;
    whatsappConf?: boolean;
    whatsappSend?: boolean;
    dateTicketDownloaded?: string;
    meetsFormativeLevel?: boolean;
    pendingPostpone?: boolean;
}

export class Participant implements ParticipantInterface {
    public id?: string | undefined;
    public checked?: boolean;
    public client?: Client;
    public confirmation?: boolean;
    public diplomaDeliverable?: boolean;
    public diplomaDelivered?: boolean;
    public emailConf?: boolean;
    public emailSend?: boolean;
    public numberOfNotes?: number;
    public notes?: Note[];
    public out?: boolean;
    public purchase?: Purchase;
    public budget?: string;
    public participantList?: boolean;
    public paymentStatus?: PaymentStatusInterface;
    public phoneConf?: boolean;
    public phoneSend?: boolean;
    public positionParticipantList?: number;
    public positionRepeaterList?: number;
    public positionWaitingList?: number;
    public postpone?: boolean;
    public postponable?: boolean;
    public repeated?: boolean;
    public repeaterList?: boolean;
    public reservedSeat?: object[];
    public tag: TagInterface[];
    public ticketDownloaded?: boolean;
    public transferConvocation?: boolean;
    public waitingList?: boolean;
    public whatsappConf?: boolean;
    public whatsappSend?: boolean;
    public dateTicketDownloaded?: string;
    public meetsFormativeLevel?: boolean;
    public pendingPostpone?: boolean;

    public constructor() {
        this.notes = [];
        this.tag = [];
    }
}
